import React from 'react';
import Marquee from 'react-fast-marquee';

const PHRASES = [
    'Premium Craftsmanship',
    'Veteran Owned & Operated',
    'Interior · Exterior · Cabinet · Stucco · Commercial',
    'Serving all of New Mexico',
    'Est. Rio Rancho',
];

export const EditorialMarquee = () => {
    return (
        <section
            data-testid="msd-marquee"
            className="relative z-20 bg-ink-900 py-14 md:py-20 border-y border-white/10 overflow-hidden"
            aria-hidden="true"
        >
            <Marquee gradient={false} speed={22} pauseOnHover={false}>
                {PHRASES.concat(PHRASES).map((phrase, i) => (
                    <span
                        key={i}
                        className={`font-display font-black uppercase tracking-tight leading-none mr-14 text-[14vw] md:text-[10rem] lg:text-[12rem] ${
                            i % 3 === 1 ? 'text-outline-red' : 'text-outline'
                        }`}
                    >
                        {phrase}
                        <span className="mx-8 text-adobe-500 align-middle">·</span>
                    </span>
                ))}
            </Marquee>
        </section>
    );
};
